import { useEffect, useState } from 'react';
import type { ILayoutNumberProps } from './ILayoutNumberProps';

/**
 * Числовий параметр сітки (прототип v4 gsUnit / gsGroupMin / gsLongOpt): підпис 11px великими, поле 110px і підказка з межами; значення
 * зберігається, коли поле втрачає фокус або натиснуто Enter, — обмежене межами; Escape повертає збережене.
 */
export function LayoutNumber({ label, hint, value, min, max, disabled, onCommit }: ILayoutNumberProps) {
  const [draft, setDraft] = useState(String(value));
  useEffect(() => setDraft(String(value)), [value]);
  const commit = () => {
    const n = Number(draft);
    if (!draft.trim() || Number.isNaN(n)) { setDraft(String(value)); return; }
    const next = Math.max(min, Math.min(max, Math.round(n)));
    setDraft(String(next));
    if (next !== value) onCommit(next);
  };
  return (
    <label className="cu-num">
      <span className="cu-def__label cu-upper">{label}</span>
      <span className="cu-num__row">
        <input className="sp-input cu-num__input" type="number" min={min} max={max} value={draft} disabled={disabled} onChange={(e) => setDraft(e.target.value)} onBlur={commit}
          onKeyDown={(e) => { if (e.key === 'Enter') commit(); if (e.key === 'Escape') setDraft(String(value)); }} />
        <span className="sp-muted">{hint}</span>
      </span>
    </label>
  );
}
